import { useState } from "react";
import { CellInput, NumInput } from "../ui/Field";
import { useT } from "../../lib/i18n";
import { bToG, gSavedAs, gToB, usableE } from "../../lib/g-unit";

/**
 * 按「几倍单掷金币」（×g）填、按 B 个数存的输入框（换算口径见 lib/g-unit.ts）。
 *
 * 进出都是 B：调用方的草稿、校验、自动保存照旧按 B 走，只有这一格显示成 ×g。
 * 后面带单位（E 可用时「倍单掷金币」，否则「B」）；输入取整到 1 个 B 后显示不一样时，
 * 旁边写「实际按 X 倍保存」，不悄悄改值。
 *
 * 记住人最后敲的那个数（typed）：只要它换算出来的 B 还是当前值，就照它显示——
 * 否则 E = 3.1 敲「1」会立刻被换成 0.968，正在打的字被吞掉。外面把值改掉（还原、切版本）后自动让位。
 */
export function GNumInput({ valueB, onChangeB, e, disabled, className, cell, cellClassName, noUnit }: {
  valueB: number | null;
  onChangeB: (b: number | null) => void;
  /** E（每掷平均产出几个 B）；缺失 / 0 / 非数时按 B 原样显示和输入 */
  e: number | null | undefined;
  disabled?: boolean;
  className?: string;
  /** 表格里的紧凑格（spin 表）：用 CellInput，外面套一层定宽（cellClassName） */
  cell?: boolean;
  cellClassName?: string;
  /** 不在框后写单位（同一行有几个框、单位由调用方统一写一次时） */
  noUnit?: boolean;
}) {
  const t = useT();
  const [typed, setTyped] = useState<number | null>(null);
  const hasE = usableE(e) != null;
  const own = typed != null && gToB(typed, e) === valueB;
  const shown = own ? typed : bToG(valueB, e);
  const savedAs = own ? gSavedAs(typed, e) : null;
  const onChange = (v: number | null) => { setTyped(v); onChangeB(gToB(v, e)); };
  return (
    <>
      {cell
        ? <span className={cellClassName}><CellInput value={shown} disabled={disabled} onChange={onChange} /></span>
        : <NumInput value={shown} disabled={disabled} className={className} onChange={onChange} />}
      {!noUnit && <span className="text-xs text-ink-placeholder">{t(hasE ? "tile.unit.g" : "u.B")}</span>}
      {savedAs != null && <span className="text-xs text-warning">{t("tile.gSavedAs", { x: savedAs })}</span>}
    </>
  );
}
